
import PeerRecognition from "../employee-recognition/PeerRecognition";

export { Page }

function Page() {
  return <PeerRecognition />;
}
